import { isEmpty, isEqual } from 'lodash'

function areTenantAddressEqual(tenant) {
  const mailingAddressValues = [
    tenant.mailingAddress1,
    tenant.mailingAddress2,
    tenant.mailingCity,
    tenant.mailingState,
    tenant.mailingZip,
  ]
  const physicalAddressValues = [
    tenant.physicalAddress1,
    tenant.physicalAddress2,
    tenant.physicalCity,
    tenant.physicalState,
    tenant.physicalZip,
  ]

  if (isEmpty(mailingAddressValues) || isEmpty(physicalAddressValues))
    return false

  return isEqual(mailingAddressValues, physicalAddressValues)
}

export default areTenantAddressEqual
